// ======================================================================
// File Name       : userHistoryStudent
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { hasProperty } from '../utils';
import * as ActionTypes from '../constants/actionTypes/userHistoryStudent';
import * as ReportConstants from '../constants/ScoringReportConstants';

const INITIAL_STATE = {
  userHistoryData: {},
  userHistoryDetailData: {
    drillResultByStd: {
      drillSecernId: '',
      drillName: '',
      drillExeTime: '',
      learningRecord: '',
      questionResultList: [],
    },
  },
};

export default function userHistoryStudent(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.USER_HISTORY_STUDENT_GET_GROUP_LIST: {
      const { groupList } = action;
      return {
        ...state,
        userHistoryData: { ...state.userHistoryData, ...{ groupList } },
      };
    }

    case ActionTypes.USER_STUDENT_GET_GROUP_RELATION_LIST: {
      const { groupRelationList } = action;
      return {
        ...state,
        userHistoryData: { ...state.userHistoryData, ...{ groupRelationList } },
      };
    }

    case ActionTypes.USER_STUDENT_GET_USER_LIST: {
      const { userList, recordNum } = action;
      const userHistoryData = {
        ...state.userHistoryData,
        userList,
        recordNum,
      };
      return {
        ...state,
        userHistoryData,
      };
    }

    case ActionTypes.RECEIVE_USER_HISTORY_DETAIL_INIT: {
      const { userList, groupRelationList, groupList } = action;
      const userHistoryData = {
        ...state.userHistoryData,
        userList,
        groupRelationList,
        groupList,
      };
      return {
        ...state,
        userHistoryData,
      };
    }

    case ActionTypes.GET_EACH_USER_COURSE_STATUS_COUNT: {
      const { courseStatusList } = action;
      let eachUserCourseStatusCount = {};
      if (courseStatusList) {
        eachUserCourseStatusCount = courseStatusList.reduce((acc, cur) => {
          if (cur && cur.userSecernId) {
            const { userSecernId } = cur;
            acc[userSecernId] = cur;
          }
          return acc;
        }, eachUserCourseStatusCount);
      }
      return {
        ...state,
        eachUserCourseStatusCount,
      };
    }

    case ActionTypes.USER_STUDENT_GET_COURSE_STATUS_LIST: {
      const { courseStatusList } = action;
      if (courseStatusList && courseStatusList.length) {
        return {
          ...state,
          userHistoryData: { ...state.userHistoryData, ...{ courseStatusListForList: courseStatusList } },
        };
      }
      return {
        ...state,
        userHistoryData: { ...state.userHistoryData, ...{ courseStatusList } },
      };
    }

    case ActionTypes.USER_STUDENT_GET_COURSE_INFO_LIST: {
      const { courseList } = action;
      const userHistoryData = {
        ...state.userHistoryData,
      };
      const { courseStatusListForList } = userHistoryData;
      const courseListTemp = courseList && courseList.reduce(
        (acc, cur) => {
          const { courseSecernId } = cur;
          acc.byId[courseSecernId] = cur;
          acc.allIds.push(courseSecernId);
          return acc;
        },
        {
          byId: {},
          allIds: [],
        },
      );

      courseStatusListForList && courseStatusListForList.length &&
      courseStatusListForList.forEach((item) => {
        if (courseListTemp.byId[item.courseSecernId]) {
          item.courseName = courseListTemp.byId[item.courseSecernId].courseName;
          if (item.courseStatus === 0) {
            item.courseTitleStatus = '未達成';
          } else {
            item.courseTitleStatus = '達成';
          }
        }
      });
      return {
        ...state,
        userHistoryData:
        { ...state.userHistoryData, ...{ courseStatusList: courseStatusListForList } },
      };
    }

    case ActionTypes.USER_STUDENT_GET_HISTORY_LIST: {
      const { learningHistoryList, recordNum } = action;
      if (!learningHistoryList || !learningHistoryList.length) {
        return {
          ...state,
          userHistoryDetailData:
          { ...state.userHistoryDetailData, ...{ learningHistoryList, recordNum } },
        };
      }
      return {
        ...state,
        userHistoryDetailData:
        { ...state.userHistoryDetailData,
          ...{ learningHistoryListTemp: learningHistoryList, recordNum } },
      };
    }

    case ActionTypes.USER_STUDENT_GET_COURSE_LIST: {
      const { courseList } = action;
      return {
        ...state,
        userHistoryData:
        { ...state.userHistoryData, ...{ courseList } },
      };
    }

    case ActionTypes.USER_STUDENT_GET_CONTENT_LIST: {
      const { contentList } = action;
      const userHistoryDetailData = {
        ...state.userHistoryDetailData,
      };
      const { learningHistoryListTemp } = userHistoryDetailData;
      const contentListTemp = contentList && contentList.reduce(
        (acc, cur) => {
          const { contentSecernId } = cur;
          acc.byId[contentSecernId] = cur;
          acc.allIds.push(contentSecernId);
          return acc;
        },
        {
          byId: {},
          allIds: [],
        },
      );

      learningHistoryListTemp.forEach((item) => {
        if (contentListTemp.byId[item.contentSecernId]) {
          item.contentName = contentListTemp.byId[item.contentSecernId].contentName;
        }
      });

      return {
        ...state,
        userHistoryDetailData:
        { ...state.userHistoryDetailData, ...{ learningHistoryList: learningHistoryListTemp } },
      };
    }

    case ActionTypes.USER_STUDENT_GET_ITEM_LIST: {
      const { itemList } = action;
      const { userHistoryDetailData } = state;
      
      const itemListTemp = itemList && itemList.reduce(
        (acc, cur) => {
          const { itemSecernId } = cur;
          acc.byId[itemSecernId] = cur;
          acc.allIds.push(itemSecernId);
          return acc;
        },
        {
          byId: {},
          allIds: [],
        },
      );
      const newUserHistoDetailData = {
        ...userHistoryDetailData,
        itemList: itemListTemp,
      };
      return {
        ...state,
        userHistoryDetailData: newUserHistoDetailData,
      };
    }

    case ActionTypes.USER_HISTORY_STUDENT_OPEN_GROUP_DIALOG: {
      const { userHistoryData } = action;
      return { ...state, ...{ userHistoryData } };
    }

    case ActionTypes.RECEIVE_QUESTION_USE_RECORD_BY_STD: {
      const { result } = action;
      return {
        ...state,
        userHistoryDetailData: {
          ...state.userHistoryDetailData,
          userResult: result,
        },
      };
    }

    case ActionTypes.RECEIVE_DRILL_ENFORCE_HISTORY_BY_STD: {
      const { drillResult, partQuestionList } = action;
      const drillResultByStd = {};
      if (!drillResult) {
        return {
          ...state,
          userHistoryDetailData: {
            ...state.userHistoryDetailData,
            drillResultByStd,
          },
        };
      }
      drillResult.drillExeTime !== undefined &&
        (drillResultByStd.drillExeTime = drillResult.drillExeTime);
      drillResult.drillName && (drillResultByStd.drillName = drillResult.drillName);
      drillResult.drillSecernId && (drillResultByStd.drillSecernId = drillResult.drillSecernId);
      drillResult.drillStartDate && (drillResultByStd.drillStartDate = drillResult.drillStartDate);
      const questionResults = [];
      let countRight = 0;
      if (
        drillResult.drillResultInfo.questionResultList &&
        drillResult.drillResultInfo.questionResultList.length
      ) {
        const length = drillResult.drillResultInfo.questionResultList.length;
        const questionResultList = drillResult.drillResultInfo.questionResultList;
        for (let i = 0; i < length; i++) {
          const question = questionResultList[i];
          let questionToAdd = {};
          if (question.answerJudgeResult === 99) {
            const match = partQuestionList.filter((item, index) => (
              item &&
              item.questionSecernId === question.questionSecernId &&
              item.drillSecernId === drillResultByStd.drillSecernId
            ))[0];
            if (match && match.subQuestionArray && match.subQuestionArray.length) {
              const subQuestionArray = match.subQuestionArray;
              for (let j = 0; j < subQuestionArray.length; j++) {
                questionToAdd = subQuestionArray[j];
                questionToAdd.questionSecernId = question.questionSecernId;
                questionToAdd.label = `${i + 1}-${j + 1}`;
                let subAnswerJudgeResult = isNaN(questionToAdd.subAnswerJudgeResult) ?
                null : parseInt(questionToAdd.subAnswerJudgeResult, 10);
                if (
                  subAnswerJudgeResult !== ReportConstants.ANSWER_JUDGE_RESULT.CORRECT &&
                  subAnswerJudgeResult !== ReportConstants.ANSWER_JUDGE_RESULT.NOT_ANSWER
                ) {
                  subAnswerJudgeResult = ReportConstants.ANSWER_JUDGE_RESULT.INCORRECT;
                }
                questionToAdd.result = subAnswerJudgeResult;
                if (questionToAdd.result === ReportConstants.ANSWER_JUDGE_RESULT.CORRECT) {
                  countRight++;
                }
                questionResults.push(questionToAdd);
              }
            }
          } else {
            questionToAdd = question;
            questionToAdd.label = `${i + 1}`;
            let answerJudgeResult = isNaN(questionToAdd.answerJudgeResult) ?
            null : parseInt(questionToAdd.answerJudgeResult, 10);
            if (answerJudgeResult !== ReportConstants.ANSWER_JUDGE_RESULT.CORRECT &&
              answerJudgeResult !== ReportConstants.ANSWER_JUDGE_RESULT.NOT_ANSWER) {
              answerJudgeResult = ReportConstants.ANSWER_JUDGE_RESULT.INCORRECT;
            }
            questionToAdd.result = answerJudgeResult;
            if (questionToAdd.result === ReportConstants.ANSWER_JUDGE_RESULT.CORRECT) {
              countRight++;
            }
            questionResults.push(questionToAdd);
          }
        }
        drillResultByStd.questionResultList = questionResults;
        drillResultByStd.learningRecord = `${countRight}/${questionResults.length}`;
        // #6801 START
        drillResultByStd.drillResultExp = drillResult.drillResultInfo.drillResultExp;
        drillResultByStd.drillResultNum = drillResult.drillResultInfo.drillResultNum;
        drillResultByStd.questionCount = drillResult.drillResultInfo.questionCount;
        drillResultByStd.perfectPoint = drillResult.drillResultInfo.perfectPoint;
        // #6801 END
      }
      return {
        ...state,
        userHistoryDetailData: {
          ...state.userHistoryDetailData,
          drillResultByStd,
        },
      };
    }

    case ActionTypes.RECEIVE_QUESTION_HTML_DETAIL: {
      const { redirectUri } = action;
      return {
        ...state,
        userHistoryDetailData: {
          ...state.userHistoryDetailData,
          redirectUri,
        },
      };
    }

    case ActionTypes.SAVE_HISTORY_COURSE_DETAIL: {
      const { courseDetail } = action;
      return {
        ...state,
        courseDetail,
      };
    }

    case ActionTypes.RESET_HISTORY_COURSE_DETAIL: {
      return {
        ...state,
        courseDetail: {},
      };
    }

    case ActionTypes.RESET_LEARNING_HISTORY_LIST: {
      // Reset data
      return {
        ...state,
        userHistoryDetailData: {
          ...state.userHistoryDetailData,
          learningHistoryList: [],
          learningHistoryListTemp: [],
          recordNum: 0,
        },
      };
    }

    case ActionTypes.RESET_COURSE_STATUS_LIST: {
      const courseStatusList = [];
      return {
        ...state,
        userHistoryData: { ...state.userHistoryData, ...{ courseStatusList } },
      };
    }

    default:
      return state;
  }
}
